import Layout from '../UI/Layout/Layout'
import Cube from '../UI/Cube/Cube'
import props from '../../redux/props'
import { useSelector } from 'react-redux'
import rotateImage from '../../assets/image/cube/rotate.svg'
import { ItemList } from '../UI/Cube/types'
import Popup from './Popup/Popup'
import VideoPopup from './Popup/VideoPopup/VideoPopup'
import { Gender } from '../hooks/useCubeItems/kandi/wahlkreisData'

type Props = {
  items: ItemList
  showPopup?: boolean
  showVideoPopup?: boolean
  gender?: Gender
  isTopic?: boolean
}

const CubePageTemplate: React.FC<Props> = ({ items, showPopup = false, showVideoPopup = false, gender, isTopic }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <Layout headerTransparent disableHeaderPadding>
      <div className="h-[90vh]">
        <Cube items={items} />
      </div>
      <div className="absolute w-full bottom-10 flex flex-col gap-3 items-center">
        <img src={rotateImage} className="h-7" alt="Rotate" />
        <div className="text-white text-sm text-center 2xl:hidden">{t.cube.rotate}</div>
        <div className="text-white text-sm text-center hidden 2xl:block">{t.cube.rotateDesktop}</div>
      </div>
      {showPopup && <Popup />}
      {showVideoPopup && <VideoPopup gender={gender} isTopic={isTopic} />}
    </Layout>
  )
}

export default CubePageTemplate
